import { Box, Button, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import bankAccountInfo from "../../../../../../media/images/icons/BankAccountInfo.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";

export default function BankAccountInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        border: "1px solid gray",
        borderRadius: "10px",
        padding: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: "4px",
          borderBottom: isOpen ? "1px solid gray" : "",
          paddingBottom: isOpen ? "8px" : "",
          transition: "padding 0.2s ease",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",

            gap: "4px",
          }}
        >
          <img width={32} src={bankAccountInfo} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                fontWeight: "600",
                color: "primary.main",
              }}
            >
              حساب بانکی
            </Typography>
            <Typography>شماره شبا، شماره حساب، شماره کارت</Typography>
          </Box>
        </Box>
        <Button
          onClick={() => toggleBox()}
          sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid gray",
            minWidth: "0px !important",
            height: "fit-content",
            padding: "10px 8px",
            gap: "4px",
            borderColor: isOpen
              ? `${theme.palette.error.main} !important`
              : `${theme.palette.secondary.main} !important`,
            backgroundColor: isOpen
              ? `${theme.palette.error.light} !important`
              : `${theme.palette.secondary.light} !important`,
            "& .MuiTouchRipple-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              padding: "0px",
            },
            "& .MuiButtonBase-root": {
              color: `${theme.palette.error.main} !important`,
              borderWidth: "0px !important",
              minWidth: "0px !important",
              padding: "0px",
            },
            "& .MuiButton-root": {
              minWidth: "0px !important",
            },
          }}
        >
          {isOpen ? (
            <Typography
              sx={{
                color: isOpen ? "error.main" : "secondary.main",
                fontSize: "12px",
                fontWeight: "600",
                whiteSpace: "nowrap",
              }}
            >
              بستن جزئیات
            </Typography>
          ) : (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
                color: isOpen ? "error.main" : "secondary.main",
                whiteSpace: "nowrap",
              }}
            >
              مشاهده/ویرایش{" "}
            </Typography>
          )}
          <ArrowDownSVG
            size={14}
            color={
              isOpen ? theme.palette.error.main : theme.palette.secondary.main
            }
          />
        </Button>
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1000px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "6px",
        }}
      >
        <Box
          sx={{
            mt: 1,
            backgroundColor: "primary.light",
            borderRadius: "8px",
            padding: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
            }}
          >
            بعد از تغییر اطلاعات یا ناوگان، حساب شما به حالت احرازنشده تبدیل
            می‌شود و نیاز است دوباره عکس مدارک خود را در بخش مدارک ارسال کنید تا
            احراز هویت کامل شود.{" "}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
